<template>
    <div class="hero-container">
        <div class="row-custom container-xl">
            <div class="flex-start content-section"
                :class="{ 'ar-margin': $i18n.locale === 'ar', 'en-margin': $i18n.locale !== 'ar' }">
                <h1 class="font-48 color-primary2 fw-500 text-start text-start">
                    {{ $t(translationKey + ".title") }}
                </h1>
                <p class="fw-400 font-18 text-start text-start">{{ $t(translationKey + ".description") }}</p>
                <a
                    :href="`${BASE_FRONT_URL}` + `/${$i18n.locale}` + '/dashboard/rfq' + `${refId ? '?ref=' + refId : ''}`">
                    <CommonButton translationKey="store_with_us" />
                </a>
            </div>

            <div class="cta-wrapper">
                <img :src="require('@/assets/images/' + imgLink + '.png')" />
            </div>
        </div>
        <img src="@/assets/images/hero-slide-faq.png" class="background-slide-image" alt="background-slide-image" />
    </div>
</template>
  
<style lang="scss" scoped>
.hero-container {
    overflow: hidden;
    width: 100%;
    position: relative;
    height: auto;
    //z-index: 1;
    padding: 0px 0px 0px 0px;

    @media screen and (max-width: 1024px) {
        padding: 0 24px;

    }

    @media screen and (max-width:500px) {
        padding: 0 16px;
        margin-top: 15px;

    }
}

.row-custom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    margin-top: 58px;
    position: relative;
    margin-bottom: 0px;

    @media (max-width: 1024px) {
        flex-direction: column;
        align-items: flex-start;
        width: 100% !important;
    }

    h1 {
        margin: 0;
        padding: 0;
    }

    p {
        color: #5d5d5d;
        margin-top: 24px;
    }

    .cta-wrapper {
        @media (max-width: 1200px) {
            margin-top: 10px;
            width: 50% !important;
        }

        button {
            font-weight: 600;
            font-size: 1.125rem;
            background: $YELLOW_ACCENT;
            color: $SECONDARY_TEXT_COLOR !important;
        }

        img {

            // width: 570px;


            @media (max-width: 1024px) {
                margin-top: 10px;
                width: 100% !important;
            }

            @media screen and (max-width:500px) {
                width: 100% !important;
            }
        }
    }

    .content-section {
        width: 575px;

        @media screen and (max-width:1200px) {
            width: 50% !important;
        }

        @media screen and (max-width:1024px) {
            width: 100% !important;
        }

        @media screen and (max-width:500px) {
            width: 100% !important;
        }
    }
}

.background-slide-image {
    padding: 0;
    margin: 0;
    position: absolute;
    bottom: 0;
    z-index: -1;
    width: 100%;
}

.ar-margin {
    padding-right: 30px;
}

.en-margin {
    padding-left: 30px;
}
</style>
  
<script>
 
import CommonButton from "@/components/global/CommonButton.vue";
import { env } from "@/static/env";
export default {
    props: ["translationKey", "imgLink"],
    components: {
        CommonButton,
    },
    computed: {
        refId() {
            return this.$route.query.ref;
        }
    },
    data() {
        return {
            BASE_FRONT_URL: env.BASE_FRONT_URL
        }
    },
};
</script>
  